import type { ReactNode } from 'react';

export const symbol_range_hood: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24.75 0-42.37-17.63Q80-195.25 80-220v-188q0-16 6.5-30.5T104-464l176-176v-140q0-24.75 17.63-42.38Q315.25-840 340-840h280q24.75 0 42.38 17.62Q680-804.75 680-780v140l182 182q8 8 13 19.28 5 11.28 5 23.72v195q0 24.75-17.62 42.37Q844.75-160 820-160H140Zm340-620H340v139q0 12.44-5 23.72T322-598L192-468h576L638-598q-8-8-13-19.28-5-11.28-5-23.72v-139H480ZM140-220h680v-188H140v188Zm280-74q-8 0-14-6t-6-14q0-8 6-14t14-6h120q8 0 14 6t6 14q0 8-6 14t-14 6H420Z"
		/>
	</svg>
);
